<template>
	<div class="divcreateorder">
		<international ref="dhl" v-show="type=='DHL国际件'" :urlparam="pageparam" :curpkval="curpkval" :iscopy="iscopy"></international>
	</div>

</template>
<script>
import international from '@/components/order/logistics_createorder_international.vue';
export default {
	components: {
		international
	},
	props: {
		urlparam: {
			type: Object,
			default: {}
		}
	},
	data() {
		return {
			pageparam:{},
			curpkval:'',
			iscopy:0,
			type:''
		}
	},
	mounted() {
		if (this.urlparam!= undefined) {
			this.pageparam=this.urlparam;
			if (this.urlparam.pkval != undefined) {
				this.curpkval = this.urlparam.pkval;
				if (this.urlparam.iscopy != undefined) {
					this.iscopy = this.urlparam.iscopy;
				}
			}
		}
		var that=this;
		//this.$tool.loading('正在加载', 'divcreateorder');
		//判断是哪种类型的下单功能,显示对应组件
		this.$apipost.get.CreatePageLayoutType({ sys: '出口系统', fun:'国际件下单'}).then(res => {
		//	this.$tool.loadingclose();
			if (res != '') {
				if (res.list.length > 0) {
					var list=res.list;
					setTimeout(function(){
						for(var i=0;i<list.length;i++){
							if(list[i].l_type=='DHL国际件'){
								if (that.$refs.dhl != undefined) {
									that.$refs.dhl.init();
									that.type=list[i].l_type;
									break;
								}
							}
						}
					},30);
				}
			}
		});
	}
}
</script>